/**
* 订单管理 交易订单
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>充值记录列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" style="margin-top: 20px;">
      <el-form-item>
        <el-input size="small" v-model="userName" placeholder="请输入用户昵称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input size="small" v-model="mobile" placeholder="请输入用户手机号"></el-input>
      </el-form-item>
      <el-form-item label="订单状态">
        <el-select size="small" v-model="status" placeholder="请选择订单状态">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="充值类型">
        <el-select size="small" v-model="payWay" placeholder="请选择充值类型">
          <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="chongzhi">重置</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
      element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" sortable type="index" label="序号"></el-table-column>
      <el-table-column align="center" prop="userName" label="用户昵称" width="100"></el-table-column>
      <el-table-column align="center" prop="money" label="充值金额" width="100"></el-table-column>
      <el-table-column align="center" prop="num" label="到账钻石数" width="100"></el-table-column>
      <el-table-column align="center" sortable prop="payWay" label="充值类型" width="120" show-overflow-tooltip>
        <template slot-scope="scope">
          <div v-if="scope.row.payWay == 0">微信</div>
          <div v-if="scope.row.payWay == 1">支付宝</div>
          <div v-if="scope.row.payWay == 2">苹果</div>
        </template>
      </el-table-column>
      <el-table-column align="center" sortable prop="status" label="订单状态" width="120" show-overflow-tooltip>
        <template slot-scope="scope">
          <div v-if="scope.row.status == 0">待支付</div>
          <div v-if="scope.row.status == 1">成功</div>
          <div v-if="scope.row.status == 2">失败</div>
        </template>
      </el-table-column>
      <el-table-column align="center" sortable prop="createTime" label="创建时间" width="180" show-overflow-tooltip>
        <template slot-scope="scope">
          <div>{{ transformDate(scope.row.createTime) }}</div>
        </template>
      </el-table-column>

    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

  </div>
</template>

<script>
import { getAdminBalanceList } from '../../api/userMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 20,
        total: 10
      },
      userName: '',
      mobile: '',
      payWay: -1,
      status: -1,
      options: [
        {
          value: -1,
          label: '全部'
        }, {
          value: 0,
          label: '待支付'
        }, {
          value: 1,
          label: '成功'
        }, {
          value: 2,
          label: '失败'
        }
      ],
      options1: [
        {
          value: -1,
          label: '全部'
        }, {
          value: 0,
          label: '微信'
        }, {
          value: 1,
          label: '支付宝'
        }, {
          value: 2,
          label: '苹果'
        }
      ]
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getOrderList(1)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 搜索数据
    search() {
      this.getOrderList(1)
    },
    // 重置数据
    chongzhi() {
      this.userName = ''
      this.mobile = ''
      this.payWay = -1
      this.status = -1
      this.getOrderList(1)
    },
    // 获取订单列表
    getOrderList(page) {
      this.loading = true;
      var parameter = {
        status: this.status,
        page: (page - 1) * 20,
        userName: this.userName,
        payWay: this.payWay,
        mobile: this.mobile,
      };
      getAdminBalanceList(parameter).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.listData = res.data.list
          this.pageparm.currentPage = page
          this.pageparm.total = res.data.count
          return;
        }
        this.$message({
          type: "info",
          message: res.msg,
        });
      });
    },

    // 分页插件事件
    callFather(parm) {
      // this.formInline.page = parm.currentPage
      // this.formInline.limit = parm.pageSize
      this.getOrderList(parm.currentPage)
    },
    // 搜索事件
    search() {
      this.getOrderList(1)
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      this.editFormVisible = true
      this.orderInfo = row;
      this.getOrderDetails()
    },


  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/views/pay/balance.vue